/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {PureComponent} from 'react';
import {ErrorType, navigate, showDialog, validateEmail} from '@dvrd/dvr-controls';
import {resetPassword} from "../../../../util/requestSender";
import ForgotPassword from "./forgotPassword";
import {getNavigationParam} from "../../../../util/navigateUtil";
import {LOGIN_ROUTE} from "../../../../util/constants";

interface State {
    email: string;
    loading: boolean;
    error: ErrorType;
}

export default class ForgotPasswordController extends PureComponent<any, State> {
    state: State = {
        email: '',
        loading: false,
        error: null,
    };

    onChange = (value: string) => {
        this.setState({email: value});
    };

    onResetError = () => {
        this.setState({error: null});
    };

    onClickBack = () => {
        navigate(LOGIN_ROUTE);
    };

    onSubmit = () => {
        if (this.validateValues()) {
            this.setState({loading: true});
            const {email} = this.state;
            resetPassword({
                data: {email}, callback: () => {
                    this.setState({loading: false});
                    showDialog(
                        'Als het e-mailadres overeenkomt met een gebruiker in onze database, dan is er een e-mail ' +
                        'verzonden met instructies om je wachtwoord opnieuw in te stellen. Het kan een aantal minuten ' +
                        'duren voordat deze mail aankomt. We raden je aan om ook je spam te controleren.',
                        'Wachtwoord opnieuw instellen');
                    navigate('/inloggen');
                }
            })
        }
    };

    validateValues = (): boolean => {
        const {email} = this.state;
        let valid: boolean = true, error: string = '';
        if (!email) {
            valid = false;
            error = 'Vul je e-mailadres in';
        } else if (!validateEmail(email)) {
            valid = false;
            error = 'Vul een geldig e-mailadres in';
        }
        if (!valid) this.setState({error});
        return valid;
    };

    componentDidMount = () => {
        const navParam = getNavigationParam();
        if (navParam && typeof navParam === 'string') this.setState({email: navParam});
    };

    render = () => {
        const {error, loading, email} = this.state;
        return (
            <ForgotPassword onChange={this.onChange} onSubmit={this.onSubmit} onResetError={this.onResetError}
                            onClickBack={this.onClickBack} email={email} error={error} loading={loading}/>
        )
    }
}